<div class="dialog-container">
    <h1 class="condensed dialog-title">Exporteer ShapeFile</h1>
    <div class="dialog-content">
        <div class="w-100">
            @if (!exporting) {
                <div class="pb-3">
                    <p>Exporteer alle locaties naar een ShapeFile (geografisch formaat).</p>
                    @for (status of statuses; track status; let i = $index) {
                        <div>
                            <mat-checkbox
                                [(ngModel)]="filter['status_' + status.id]"
                                [disabled]="filter['status_' + status.id + '_disable']"
                                [value]="String(status.id)"
                                color="primary">
                                <span [innerHTML]="status['img'] | safeHtml"></span>
                                {{status.name}}
                                @if (statusCounts.has(status.id)) {
                                    ({{statusCounts.get(status.id)}})
                                }
                            </mat-checkbox>
                        </div>
                    }
                </div>
            } @else {
                <div class="w-100">
                    Bezig met exporteren...
                    <br><br>
                    <mat-progress-bar class="w-100" mode="indeterminate"></mat-progress-bar>
                    <br><br>
                </div>
            }
        </div>
    </div>
    <div class="d-flex flex-wrap">
        <button (click)="onNoClick()" mat-button>Sluiten</button>
        <div class="spacer"></div>
        <button (click)="export()" cdkFocusInitial color="primary" mat-raised-button>Download ShapeFile</button>
    </div>
</div>
